<template lang="pug">
  #answered-questions
    WtTile
    .columns.is-centered.is-mobile(v-if="!memberLoaded")
      ContentLoader(:width="300" :height="100")
        rect(x="0", y="0", rx="4", ry="4", width="100%", height="40")
        rect(x="0", y="45", rx="4", ry="4", width="100%", height="40")
        rect(x="0", y="90", rx="4", ry="4", width="100%", height="40")
    .answered-questions-container(v-else-if="!noQuestions")
      .question-item(v-for="q in member.answeredQuestions" :key="q.id")
        .question-text
          WtLabel.question-label(
            slot="label"
            :text="q.question"
            :required="q.required"
          )
          .points-tag(
            v-if="q.pointValue"
          )
            .point-value {{q.pointValue}}
            .point-units pts
        .question-description(v-if="q.description" v-html="q.description")
        QuestionAnswers(:question="q" :previewAnswer="answerPreview(q)" :useCustomQAStyles="true")
        .answer-text Answered: {{date(q.memberAnswer.date, 'DATE_FORMAT_FULL_MONTH').formatted}}

    .columns.is-centered.is-mobile(v-else)
      WtTitle There are no questions you answered yet!
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import QuestionAnswers from "@@/ProgramQuestions/QuestionAnswers";
import { ContentLoader } from "vue-content-loader";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "MemberQuestionsAnswered",

  components: { WtTile, QuestionAnswers, ContentLoader, WtLabel, WtTitle },

  mixins: [analyticsTrackingMixin, dateUtilityMixin],

  props: {},

  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),

    noQuestions() {
      return !(
        this.member.answeredQuestions && this.member.answeredQuestions.length
      );
    }
  },

  mounted() {
    this.trackFeatureView("learn", "learn_questions_answered");
  },

  methods: {
    answerPreview(responseData) {
      if (responseData.type === "checkbox") {
        return this._.get(responseData, "memberAnswer.response", null).split(
          ","
        );
      } else {
        return this._.get(responseData, "memberAnswer.response", null);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#answered-questions
  padding-bottom: 25px
  padding-left: 25px
  padding-right: 25px
.answered-questions-container
  display: flex
  flex-direction: column
  gap: 18px
.question-item
  display: flex
  flex-direction: column
  gap: 12px
  padding-left: 16px
  padding-right: 16px
.question-text
  display: flex
  gap: 10px

.points-tag
  background-color: #B6B8BC
  display: flex
  flex-direction: row
  gap: 2px
  padding: 3px
  border-radius: 6px
  align-items: center
  justify-content: center
  width: 43px
  height: 20px

.point-value,
.point-units
  color: white
  font-weight: 700
  font-size: 10px
  letter-spacing: 0px
  line-height: 18px

.question-description
  font-weight: 400
  font-size: 14px
  line-height: 20px
  letter-spacing: 0px
  color: #5D6472

.answer-text
  font-weight: 700
  font-size: 13px
  line-height: 18px
  letter-spacing: 0px
  color: #5D6472

.question-label
  font-weight: 700
  font-size: 14px
  line-height: 20px
  letter-spacing: 0px


.question-description /deep/ a
  color: $primary
</style>
